/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_to_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To unit`)
};

const es_uc_to_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unidad de destino`)
};

const de_uc_to_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zieleinheit`)
};

const nl_uc_to_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naar eenheid`)
};

const fr_uc_to_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unité cible`)
};

const it_uc_to_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unità di destinazione`)
};

const pt_br2_uc_to_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para a unidade`)
};

const pt_uc_to_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unidade de destino`)
};

const ja_uc_to_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変換先単位`)
};

const zh_uc_to_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标单位`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_to_unit = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_to_unit(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_to_unit", locale)
	if (locale === "en") return en_uc_to_unit(inputs)
	if (locale === "es") return es_uc_to_unit(inputs)
	if (locale === "de") return de_uc_to_unit(inputs)
	if (locale === "nl") return nl_uc_to_unit(inputs)
	if (locale === "fr") return fr_uc_to_unit(inputs)
	if (locale === "it") return it_uc_to_unit(inputs)
	if (locale === "pt-BR") return pt_br2_uc_to_unit(inputs)
	if (locale === "pt") return pt_uc_to_unit(inputs)
	if (locale === "ja") return ja_uc_to_unit(inputs)
	return zh_uc_to_unit(inputs)
};